<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'子媒体列表'"
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="handleClose"
      key="subVideo"
    >
      <!--数据表格-->
      <el-table
        :data="subTableData"
        style="width: 100%"
        border
        ref="multipleTable"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @sort-change="handleSortChange"
        height="580"
      >
        <el-table-column prop="id" label="ID" align="center" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.id || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="video_id"
          label="父ID"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.video_id || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="episode_number"
          label="第几集"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="章节名"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="media_type"
          label="媒体类型"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.media_type == 1"
              >动漫</el-tag
            >
            <el-tag
              style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
              v-else-if="scope.row.media_type == 2"
              >漫画</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.media_type == 3"
              >文本小说</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.media_type == 4"
              >有声小说</el-tag
            >
            <el-tag type="info" v-else-if="scope.row.media_type == 5"
              >剧场</el-tag
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == 0">审核中</el-tag>
            <el-tag type="success" v-else-if="scope.row.status == 1"
              >通过</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.status == 2"
              >拒绝</el-tag
            >
            <el-tag type="info" v-else-if="scope.row.status == 3">下架</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="sale_coin"
          label="价格"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.sale_coin }}
          </template>
        </el-table-column>
        <el-table-column label="封面图" align="center" width="120">
          <template slot-scope="scope">
            <img-load
              :width="'80px'"
              :height="'60px'"
              :src="checkUrl(scope.row.cover) + scope.row.cover"
            >
            </img-load>
          </template>
        </el-table-column>
        <el-table-column
          prop="urls"
          label="图集预览"
          align="center"
          width="110"
        >
          <template slot-scope="scope">
            <div
              class="picturePreview"
              @click="previewPicture(scope.row.urls.split(','))"
            >
              <img-load2
                :width="'80px'"
                :height="'60px'"
                v-for="(item, i) in scope.row.urls.split(',')"
                :key="i"
                :src="checkUrl(scope.row.cover) + scope.row.cover"
              >
              </img-load2>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="play_time"
          label="总时长"
          align="center"
          width="130"
        >
          <template slot-scope="scope">{{
            scope.row.play_time | changeSecond
          }}</template>
        </el-table-column>
        <el-table-column label="预览" align="center" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.m3u8_url">
              <i
                class="el-icon-video-play views"
                title="点击预览"
                @click="checkMedia(scope.row, 'video')"
              ></i>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="audio_url"
          label="资源地址"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.audio_url">
              <audio-player
                ref="audioPlayer"
                :show-prev-button="false"
                :show-next-button="false"
                :show-volume-button="false"
                :audio-list="[$audUrl + '/' + scope.row.audio_url]"
              />
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="text" label="小说内容" align="center" width="80">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="success"
              @click="checkMedia(scope.row, 'text')"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="media_size"
          label="帖子大小(M)"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.media_size
                ? (scope.row.media_size / 1024 / 1024).toFixed(2)
                : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="width"
          label="宽"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="height"
          label="高"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="ratio"
          label="宽高比"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="拒绝原因"
          align="center"
          width="260"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.reason || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="edit_by"
          label="编辑者"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.edit_by || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="review_by"
          label="编辑者"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.review_by || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="修改时间"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span>{{ (scope.row.update_time * 1000) | changeDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span>{{ (scope.row.create_time * 1000) | changeDate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="removeVideo(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <div class="bottom">
        <div class="page">
          <el-pagination
            :page-sizes="[10, 25, 50, 100]"
            :current-page="params.page"
            :page-size="params.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            @size-change="changeSize"
            @current-change="changeCurrent"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 小说预览 -->
    <el-dialog
      :title="textPreviewTitle"
      :visible.sync="isTextPreview"
      width="800px"
      class="textPreviewDialog"
      :before-close="subClose"
    >
      <div class="textPreview">
        {{ textPreviewContent }}
      </div>
    </el-dialog>
    <!-- 漫画预览 -->
    <el-dialog
      :title="comicsPreviewTitle"
      :visible.sync="isComicsPreview"
      width="800px"
      class="comicsPreviewDialog"
      :before-close="subClose"
    >
      <div>
        <div class="comicsList" v-for="item in comicsPreviews" :key="item">
          <img-load :src="imgUrl + item"></img-load>
        </div>
      </div>
    </el-dialog>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
    <!--------------------子媒体编辑----------------------->
    <el-dialog
      :title="'子媒体编辑'"
      :visible.sync="subEdit"
      width="700px"
      :before-close="subHandleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="editParam"
        label-position="left"
        label-width="110px"
      >
        <div class="form-flex-box">
          <el-form-item label="章节名:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请谨慎修改数据"
              v-model="editParam.title"
              :disabled="editTitle"
            ></el-input>
            <el-button type="success" size="small" @click="editTitle = false"
              >修改</el-button
            >
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="第几集:" prop="coins">
            <el-input
              v-model.number="editParam.episode_number"
              size="small"
              placeholder="请输入第几集"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格:" prop="sale_coin">
            <el-input
              v-model.number="editParam.sale_coin"
              size="small"
              placeholder="请输入价格"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="封面上传:">
            <base-upload
              :cover="editParam.cover"
              :action="action"
              @successCallback="successCallback"
              :id="editParam.id"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item
            style="width: 1100px"
            label="小说:"
            v-if="mediaType === 3"
          >
            <!--小说-->
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入小说内容"
              v-model="editParam.text"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 漫画 -->
        <div style="margin-bottom: 10px" v-if="mediaType === 2">
          漫画排序（<span style="color: red">拖拽修改排序顺序</span>）
          <base-upload
            :action="action"
            @successCallback="successCallbackAdd"
            :wSize="180"
            :hSize="320"
            :width="'100px'"
            :height="'50px'"
          ></base-upload>
        </div>
        <div class="form-flex-box" v-if="mediaType === 2">
          <div class="test_wrapper" @dragover="dragover($event)">
            <transition-group class="transition-wrapper" name="sort">
              <div
                class="comicsPreview"
                v-for="(item, i) in comics"
                :key="item"
                :a="item"
                :draggable="true"
                @dragstart="dragstart(item)"
                @dragenter="dragenter(item, $event)"
                @dragover="dragover($event)"
                @dragend="dragend(item, $event)"
              >
                <img-load
                  :width="'80px'"
                  :height="'100px'"
                  :src="imgUrl + item"
                ></img-load>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="deletePicture(i)"
                ></el-button>
              </div>
            </transition-group>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="subEdit = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PreviewPicture from "./previewPicture";
import MediaPopup from "@/components/media-popup";
import baseConfig from "@/utils/serverUrlConfig";
import { sortEscape } from "@/utils/global";
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      imgUrl: baseConfig.imgUrl,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      loading: false,
      // 子列表数据
      subTableData: [],
      total: 0,
      time: "",
      // 请求列表查询
      mediaType: 1,
      mediaTypeName: "",
      params: {
        page: 1,
        size: 10,
        media_id: "", // 动漫ID
      },
      statuses: [
        {
          label: "审核中",
          value: 0,
        },
        {
          label: "通过",
          value: 1,
        },
        {
          label: "拒绝",
          value: 2,
        },
        {
          label: "下架",
          value: 3,
        },
      ],
      // 编辑
      editParam: {
        id: "",
        cover: "", // 封面图
        episode_number: 1, // 第几集
        sale_coin: 0, // 售价
        title: "", // 标题
        text: "", // 内容(小说专用)
        urlSet: [],
      },
      editTitle: true,
      subEdit: false,
      flag: false,
      // 小说预览
      isTextPreview: false,
      textPreviewTitle: "",
      textPreviewContent: "",

      // 漫画预览
      isComicsPreview: false,
      comicsPreviews: [],
      comicsPreviewTitle: "",
      oldData: {},
      newData: {},
      comics: [],
    };
  },
  components: {
    MediaPopup,
    PreviewPicture,
  },
  methods: {
    // 图集预览
    previewPicture(pictureArr) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr);
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
    // 封面图上传成功回调
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
    },
    // 新增图片上传成功回调
    successCallbackAdd(res) {
      this.comics.push(res.data.coverImg);
    },
    // 删除某张图片
    deletePicture(i) {
      if (this.comics.length === 1) {
        this.$message.error("请至少保留一张！");
        return;
      }
      this.comics.splice(i, 1);
    },
    // 获取视频列表
    getSubMediaList(type) {
      if (type === "status") {
        this.params.page = 1;
      }
      this.loading = true;
      API.queryAcgMediaContentResConfig(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.subTableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.subTableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.subTableData = [];
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.size = size;
      this.getSubMediaList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.page = number;
      this.getSubMediaList();
    },
    // 编辑回调监听
    handlerVideoList() {
      this.getSubMediaList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getSubMediaList();
    },
    handlerPreviewList() {
      this.getSubMediaList();
    },
    // 查看媒体
    checkMedia(row, type) {
      if (type === "video") {
        this.$refs.mediaPopup.open(row.m3u8_url, type);
      } else if (this.mediaType === 2) {
        this.comicsPreviewTitle = row.title;
        this.comicsPreviews = row.urlSet;
        this.isComicsPreview = true;
      } else if (type === "text") {
        this.textPreviewTitle = row.title;
        this.textPreviewContent = row.text;
        this.isTextPreview = true;
      }
      // if (this.mediaType === 1) {
      //   this.$refs.mediaPopup.open(row.m3u8_url, type);
      // } else if (this.mediaType === 2) {
      //   this.comicsPreviewTitle = row.title;
      //   this.comicsPreviews = row.urlSet;
      //   this.isComicsPreview = true;
      // } else if (this.mediaType === 3) {
      //   this.textPreviewTitle = row.title;
      //   this.textPreviewContent = row.text;
      //   this.isTextPreview = true;
      // }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.params.media_id = data.id;
      this.mediaType = data.media_type;
      if (data.mediaType === 1) {
        this.mediaTypeName = "视频";
      } else if (data.mediaType === 2) {
        this.mediaTypeName = "漫画";
      } else if (data.mediaType === 3) {
        this.mediaTypeName = "小说";
      }
      this.getSubMediaList();
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.mediaType = "";
      this.params = {
        page: 1,
        size: 10,
        media_id: "", // 动漫ID
        status: undefined, // 状态
        title: undefined, // 标题
        id: undefined, // id
      };
      this.subEdit = false;
      this.editTitle = true;
      this.editParam = {
        id: "",
        cover: "", // 封面图
        episode_number: 1,
        sale_coin: 0,
        title: "",
        text: "",
        urlSet: [],
      };
    },
    subClose() {
      this.isTextPreview = false;
      this.textPreviewTitle = "";
      this.textPreviewContent = "";
      this.isComicsPreview = false;
      this.comicsPreviews = [];
      this.comicsPreviewTitle = "";
    },
    subHandleClose() {
      this.subEdit = false;
      this.editTitle = true;
      this.editParam = {
        id: "",
        cover: "", // 封面图
        episode_number: 1,
        sale_coin: 0,
        title: "",
        text: "",
        urlSet: [],
      };
      this.comics = [];
      this.$refs.form.resetFields();
    },
    // 删除视频
    removeVideo(id) {
      this.$confirm("您确定要删除当前媒体吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteMediaContent({
          id: id,
        }).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getSubMediaList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 编辑视频
    edit(row) {
      this.subEdit = true;
      this.editParam.id = row.id;
      this.editParam.cover = row.cover;
      this.editParam.episode_number = row.episode_number;
      this.editParam.sale_coin = row.sale_coin;
      this.editParam.title = row.title;
      this.editParam.text = row.text;
      this.editParam.urlSet = row.urlSet;
      this.comics = row.urlSet;
    },
    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.editVideo();
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      if (this.mediaType == 2) {
        this.editParam.urlSet = [...this.comics];
        // console.log(this.editParam)
      }
      API.updatePublishMediaContent(this.editParam)
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.handlerVideoList();
          } else {
            this.$message.error(res.msg || "编辑失败！");
          }
          this.flag = false;
          this.subHandleClose();
        })
        .catch(() => {
          this.flag = false;
          this.subHandleClose();
        });
    },
    // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover(e) {
      e.preventDefault();
    },
    dragstart(value) {
      this.oldData = value;
    },
    // 记录移动过程中信息
    dragenter(value, e) {
      this.newData = value;
      e.preventDefault();
    },
    // 拖拽最终操作
    dragend() {
      if (this.oldData !== this.newData) {
        let oldIndex = this.comics.indexOf(this.oldData);
        let newIndex = this.comics.indexOf(this.newData);
        let newItems = [...this.comics];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldData);
        this.comics = [...newItems];
      }
      // console.log(this.comics)
    },
  },
};
</script>
<style scoped lang="scss">
.textPreviewDialog {
  /deep/ .el-dialog__body {
    max-height: 600px;
    overflow-y: auto;
  }
  // max-height: 800px;
  .textPreview {
    white-space: pre-wrap;
  }
}
.comicsPreviewDialog {
  /deep/ .el-dialog__body {
    max-height: 700px;
    overflow-y: auto;
  }
}

.videoList-box {
  // min-height: 100vh;
  min-height: 500px;
  overflow-y: auto;
}

.bottom {
  margin-top: 20px;
  padding-bottom: 20px;
  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.el-pagination {
  margin-top: 0 !important;
}

.dialog-footer {
  left: 0;
}

.tagBox {
  display: inline-block;
  margin-right: 5px;
}

.test_wrapper {
  width: 100%;
  // display: flex;
  .transition-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .comicsPreview {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
}
.views {
  color: red;
  font-size: 20px;
  cursor: pointer;
}
.picturePreview {
  max-width: 300px;
  display: flex;
}
</style>
